import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getErrorMsg } from '@blade-sxp/file-cluster/api/create-task/index';
let default_1 = class default_1 extends Vue {
    dialogVisible;
    task;
    gridData = [];
    getName(name) {
        return name || '/';
    }
    handleClose() {
        this.$emit('update:dialogVisible', false);
    }
    mounted() {
        getErrorMsg(this.task.id).then((res) => {
            // console.log('getErrorMsg', res);
            this.gridData = res;
        });
    }
};
__decorate([
    Prop()
], default_1.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "task", void 0);
default_1 = __decorate([
    Component({
        name: 'model',
        components: {},
        i18n: {
            messages: {
                en: {
                    title: 'Abnormal information ({msg})',
                    deviceName: 'Device',
                    zoneName: 'Area',
                    errorMsg: 'Reason',
                    taskName: 'taskName',
                },
                zh: {
                    title: '异常信息 ({msg})',
                    deviceName: '设备名称',
                    zoneName: '所属区域',
                    errorMsg: '错误信息',
                    taskName: '任务名称',
                },
            },
        },
    })
], default_1);
export default default_1;
